import React, { useState } from 'react';
import logo from '../logo_blade.png';
import { auth } from '../services/firebase';
import { signInWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';

function VerificacaoEmail({ email, onVoltar }) {
  const [senha, setSenha] = useState('');
  const [reenviado, setReenviado] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [mostrarCampoSenha, setMostrarCampoSenha] = useState(false);

  async function reenviarEmail() {
    if (!senha) { setMostrarCampoSenha(true); return; }
    setCarregando(true);
    setErro('');
    try {
      const resultado = await signInWithEmailAndPassword(auth, email, senha);
      await sendEmailVerification(resultado.user);
      await auth.signOut();
      setReenviado(true);
      setMostrarCampoSenha(false);
    } catch (e) {
      setErro('Senha incorreta ou erro ao reenviar.');
    }
    setCarregando(false);
  }

  return (
    <div style={{
      backgroundColor: '#111111', minHeight: '100vh',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'space-between', fontFamily: 'Arial, sans-serif',
      padding: '60px 24px 40px'
    }}>
      <img src={logo} alt="BLADE" style={{ width: '140px' }} />

      <div style={{ width: '100%', textAlign: 'center' }}>

        <div style={{
          width: '72px', height: '72px', borderRadius: '50%',
          backgroundColor: '#1a2a1a', border: '2px solid #2d4a2d',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px', fontSize: '32px'
        }}>
          ✉️
        </div>

        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#e8e8e8', marginBottom: '10px' }}>
          Verifique seu email
        </h2>
        <p style={{ fontSize: '14px', color: '#8f8f8f', marginBottom: '6px', lineHeight: '1.6' }}>
          Enviamos um link de confirmação para
        </p>
        <p style={{ fontSize: '14px', color: '#7bc47b', fontWeight: '600', marginBottom: '24px' }}>
          {email}
        </p>
        <p style={{ fontSize: '13px', color: '#7d7d7d', marginBottom: '32px', lineHeight: '1.6' }}>
          Acesse seu email, clique no link de confirmação e depois volte aqui para entrar.
        </p>

        {reenviado && (
          <div style={{
            backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d',
            borderRadius: '10px', padding: '12px', marginBottom: '16px'
          }}>
            <p style={{ fontSize: '13px', color: '#7bc47b', margin: 0 }}>Email reenviado com sucesso!</p>
          </div>
        )}

        {mostrarCampoSenha && (
          <div style={{ marginBottom: '12px', textAlign: 'left' }}>
            <label style={{ fontSize: '11px', color: '#9c9c9c', letterSpacing: '1px', textTransform: 'uppercase', display: 'block', marginBottom: '6px' }}>
              Confirme sua senha
            </label>
            <input type="password" placeholder="••••••••" value={senha}
              onChange={e => setSenha(e.target.value)}
              style={{
                width: '100%', padding: '14px', borderRadius: '10px',
                border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
                color: '#e8e8e8', fontSize: '15px', boxSizing: 'border-box',
                outline: 'none', fontFamily: 'Arial, sans-serif'
              }}
            />
          </div>
        )}

        {erro && <p style={{ fontSize: '12px', color: '#e24b4a', marginBottom: '12px' }}>{erro}</p>}

        <button onClick={reenviarEmail} disabled={carregando || reenviado} style={{
          width: '100%', backgroundColor: '#1a1a1a',
          color: reenviado ? '#444' : '#7bc47b',
          border: `0.5px solid ${reenviado ? '#252525' : '#2d4a2d'}`,
          borderRadius: '12px', padding: '14px',
          fontSize: '14px', fontWeight: '600',
          cursor: carregando || reenviado ? 'default' : 'pointer',
          fontFamily: 'Arial, sans-serif', marginBottom: '12px'
        }}>
          {carregando ? 'Enviando...' : reenviado ? 'Email reenviado ✓' : 'Reenviar email de confirmação'}
        </button>

        <button onClick={onVoltar} style={{
          width: '100%', backgroundColor: '#2d4a2d', color: '#7bc47b',
          border: 'none', borderRadius: '12px', padding: '14px',
          fontSize: '14px', fontWeight: '600', cursor: 'pointer',
          fontFamily: 'Arial, sans-serif'
        }}>
          Já confirmei — Entrar
        </button>
      </div>

      <p style={{ fontSize: '11px', color: '#333', textAlign: 'center' }}>
        BLADE — Agendamento de barbearias
      </p>
    </div>
  );
}

export default VerificacaoEmail;